import bgCurve from '@assets/playground/bg-curve.png'
import cokeBG from '@assets/playground/coke-background.jpeg'
import colaLogo from '@assets/playground/cola-logo.svg'
import { InteractionStatus } from '@azure/msal-browser'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import * as React from 'react'
import { Navigate } from 'react-router-dom'

import AnimateContent from './components/AnimateContent'
import HandImage from './components/HandImage'
import style from './login.module.scss'
import { loginRequest } from '../../auth/config'

const Login: React.FC = () => {
  const { instance, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  const isLoading = inProgress !== 'none'

  // Already signed in — don't show the login screen (prevents the
  // /login → login → /login loop once MSAL has an account).
  if (isAuthenticated && inProgress === InteractionStatus.None) {
    return <Navigate to="/" replace />
  }

  const handleLogin = async () => {
    try {
      if (!process.env.REACT_APP_CLIENT_ID || !process.env.REACT_APP_TENANT_ID) {
        alert('Missing Azure AD configuration.')
        return
      }

      // MSAL defaults navigateToLoginRequestUrl to true, so after the redirect
      // is processed it returns the browser to the page that started login.
      // Started from /login, that would drop the user back on /login (a loop).
      // Force the post-login landing page to /HomePage instead.
      await instance.loginRedirect({
        ...loginRequest,
        redirectStartPage: `${window.location.origin}`,
      })
    } catch (err) {
      console.error(err)
    }
  }

  if (inProgress !== 'none') {
    return (
      <div className="flex h-screen items-center justify-center bg-[#94000f] text-white text-lg">Initializing...</div>
    )
  }

  return (
    <div className="relative flex h-screen justify-between overflow-hidden bg-[#94000f]">
      <div className="absolute inset-0 bg-cover z-0 bg-center" style={{ backgroundImage: `url(${cokeBG})` }} />
      <img src={bgCurve} alt="Background visual" className="absolute top-0 z-1 h-full" loading="lazy" />
      <div className={`z-10 max-w-[46rem] h-full flex flex-col text-white ${style.contentWrap}`}>
        <img src={colaLogo} alt="Tenant logo" width="280" className="mb-6 z-1" />

        <div className="my-auto">
          <h1 className="headline-xxxl mb-10">Welcome to The Playground</h1>

          <AnimateContent onLogin={handleLogin} isLoading={isLoading} />
        </div>
      </div>

      <HandImage />
    </div>
  )
}

export default Login
